import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { CanonicalService } from 'src/app/canonical.service';
@Component({
  selector: 'app-financialservices',
  templateUrl: './financialservices.component.html',
  styleUrls: ['./financialservices.component.css']
})
export class FinancialservicesComponent implements OnInit {
  constructor(private meta: Meta, private title: Title, private canonicalService: CanonicalService) { 
    this.title.setTitle("Financial Service Guide | SingX");
    this.canonicalService.updateauCanonicalUrl('/financialservices');
    this.meta.updateTag({ name: 'description', content: 'We are Currency Exchangers in Australia which is globally authorised general financial product advice and dealing for non-cash payment products. Stay tuned with us for more details.' })
    this.meta.updateTag({ name: 'author', content: 'SingX' })
    this.meta.updateTag({ name: 'keywords', content: 'International Money Transfer from Australia, Money Transfer Overseas, Global Money Transfer, International Fund Transfer, International Remittance, Remit Money Overseas, Foreign Remittance, International Payment Transfer.' })
    
  }

  ngOnInit(): void {

  }

}
